import Loading from "@client/controls/Loading/component";
import * as React from "react";

export interface ContentChildren {
  header: React.ReactNode;
  body: React.ReactNode;
  footer?: React.ReactNode;
}

interface ContentProps {
  isLoading?: boolean;
  maxHeight?: string | number;
  height?: string | number;
  children: ContentChildren;
  style?: React.CSSProperties;
}

export default (props: ContentProps) => (
  <div
    className="modal-content"
    style={{ height: props.height, maxHeight: props.maxHeight, ...(props.style || {}) }}
    onMouseDown={(e) => e.stopPropagation()} /* prevent from closing when clicked inside */
  >
    {props.children.header}
    {props.isLoading ? (
      <div className="modal-body">
        <Loading isTransparent />
      </div>
    ) : (
      <>
        {props.children.body}
        {props.children.footer}
      </>
    )}
  </div>
);
